// extracted by mini-css-extract-plugin
module.exports = {"form":"ManageTalentAnswersModal_form__1KIPx","answer":"ManageTalentAnswersModal_answer__1YBVJ","buttonWrapper":"ManageTalentAnswersModal_buttonWrapper__3Rink"};